import { upperFirst } from 'lodash-es';

export const INVALID_REFRESH_TOKEN_MESSAGE = 'Unknown or invalid refresh token.';

// Auth callback error descriptions we handle and surface to the user via CallbackPage's
// clientLoader. The thrown FetchError reaches the root ErrorBoundary, so we list the
// upper-cased messages here to suppress duplicate reporting to Sentry.
export const ACCEPTABLE_ERROR_DESCRIPTIONS = {
  AUTH0_INVITE_NOT_FOUND_OR_EXPIRED: 'invitation not found or already used',
  DYNAMIC_ORG_MEMBERSHIP:
    'You do not have access to this organization. Please contact your administrator for assistance.',
  ORGANIZATION_MEMBERSHIP: 'client requires organization membership, but user does not belong to any organization',
  SSO_UNKNOWN_ERROR:
    'Sorry, something went wrong. Please try again. If the problem persists then please speak to your system administrator.',
  SSO_USER_NOT_IN_GROUP:
    'Sorry, you cannot access this service. Please speak to your system administrator in order to setup access via your identity provider.',
} as const;

const HANDLED_AUTH_CALLBACK_MESSAGES: ReadonlySet<string> = new Set(
  Object.values(ACCEPTABLE_ERROR_DESCRIPTIONS).map(upperFirst),
);

export const shouldIgnoreException = (e: Error): boolean =>
  e.message === INVALID_REFRESH_TOKEN_MESSAGE ||
  (e.cause as Error)?.message === INVALID_REFRESH_TOKEN_MESSAGE ||
  HANDLED_AUTH_CALLBACK_MESSAGES.has(e.message);
